import { Pipe, PipeTransform } from '@angular/core';
import { getProductSearchKeys } from '../helpers/search.helper';

@Pipe({
  name: 'productFilter'
})
export class ProductFilterPipe implements PipeTransform {

  transform(products: any, searchString: string, sortType: string) {
    console.log('ProductFilterPipe', sortType, products);
    products = !searchString ? products : // if no narrow text yet, use all
      products.filter((product) => getProductSearchKeys() // map over each search string
      .map((searchKey => (product.item || product)[searchKey].toUpperCase().indexOf(searchString.toUpperCase()) !== -1)) // true or false on any contains
      .reduce((cumulative, elem) => cumulative === true || elem === true)); // reduce into one answer
    if (sortType === 'Genus') {
      products.sort((a, b) => {
        if((a.item || a).genus < (b.item || b).genus) return -1;
        if((a.item || a).genus > (b.item || b).genus) return 1;
        return 0;
      });
    }
    if (sortType === 'Name') {
      products.sort((a, b) => {
        if((a.item || a).name_common < (b.item || b).name_common) return -1;
        if((a.item || a).name_common > (b.item || b).name_common) return 1;
        return 0;
      });
    }
    if (sortType === 'Availability') {
      products.sort((a, b) => {
        if((a.item || a).locations.length < (b.item || b).locations.length) return 1;
        if((a.item || a).locations.length > (b.item || b).locations.length) return -1;
        return 0;
      });
    }
    if (sortType === 'Distance') {
      products.forEach(p => {
        p.locations.sort((a, b) => (a.item || a).distanceToMe - (b.item || b).distanceToMe);
      })
    }
    return products;
  }
}
